import { jsx as _jsx } from "react/jsx-runtime";
import { UserIcon } from '@icons';
import cx from 'classnames';
import { useMemo } from 'react';
import styles from './avatar.module.scss';
const Avatar = ({ size = 'sm', children, letter = '', }) => {
    const wrapperClass = useMemo(() => cx(styles.avatar, styles[size]), [size]);
    const content = useMemo(() => {
        if (children) {
            return children;
        }
        if (letter) {
            return letter;
        }
        return _jsx(UserIcon, {});
    }, [children, size]);
    return (_jsx("div", { className: wrapperClass, role: "img", children: _jsx("span", { className: styles.icon_container, children: content }) }));
};
Avatar.displayName = 'Avatar';
export { Avatar };
